import type { ComposeSnapshotSyncBlockedReason } from '../../enums/composeSnapshotSyncBlockedReason';
import type { ComposeSnapshot } from '../../models/composeSnapshot';
import {
  getComposeSnapshot,
  putComposeSnapshot,
} from '../../store/utils/composeSnapshotCache';

// Re-read first: the owner session may have released or replaced the row while the request ran.
export const markSnapshotBlocked = async (
  snapshot: Pick<ComposeSnapshot, 'userId' | 'sessionId'>,
  reason: ComposeSnapshotSyncBlockedReason,
  conflictDraftVersion?: string,
): Promise<void> => {
  const current = await getComposeSnapshot(snapshot.userId, snapshot.sessionId);
  if (current) {
    await putComposeSnapshot({
      ...current,
      syncBlockedReason: reason,
      conflictDraftVersion,
    });
  }
};
